"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initBlizzardWebClient = exports.setBlizzardHasBeenInitialized = exports.hasBlizzardBeenInitialized = void 0;
const blizzard_1 = require("@snapchat/blizzard");
const web_extraction_1 = require("@snapchat/web-extraction");
const web_log_1 = require("@snapchat/web-log");
const graphene_1 = __importDefault(require("@snapchat/graphene"));
const observable_1 = require("./utils/observable");
const web_sc_cookies_1 = require("@snapchat/web-sc-cookies");
const web_env_1 = require("@snapchat/web-env");
exports.hasBlizzardBeenInitialized = false;
function setBlizzardHasBeenInitialized(setVal) {
    exports.hasBlizzardBeenInitialized = setVal;
}
exports.setBlizzardHasBeenInitialized = setBlizzardHasBeenInitialized;
const SNAPCHAT_COM_METRICS_SSO_URL = "https://accounts.snapchat.com/accounts/sso?client_id=snapchat-com-metrics";
function callAccountsSSO(authState, isProd) {
    if (graphene_1.default.isReady()) {
        graphene_1.default.increment({
            metricsName: "BlizzardEvents.InitBlizzard.CallAccountsSSO",
            value: 1,
        });
    }
    // Avoid calling /accounts/sso if nonce cookie is not set
    if (isProd && !(0, web_sc_cookies_1.hasNonceCookieSet)()) {
        if (graphene_1.default.isReady()) {
            graphene_1.default.increment({
                metricsName: "BlizzardEvents.InitBlizzard.NonceCookieNotSet",
                value: 1,
            });
        }
        authState.next(blizzard_1.UNAUTH_STATE);
        return;
    }
    fetch(SNAPCHAT_COM_METRICS_SSO_URL, {
        method: "POST",
        // include the necessary accounts cookies with the request
        credentials: "include",
        keepalive: true,
        // dont automatically follow redirects to the login page if user is not logged-in
        redirect: "manual",
    })
        .then((resp) => {
        if (resp.status === 200) {
            void resp.text().then((ssoToken) => {
                authState.next({
                    authStatus: blizzard_1.AuthStatus.AUTHENTICATED,
                    ssoToken,
                });
            });
            if (graphene_1.default.isReady()) {
                graphene_1.default.increment({
                    metricsName: "BlizzardEvents.InitBlizzard.AuthTokenFetchSuccess",
                    value: 1,
                });
            }
        }
        else {
            if (graphene_1.default.isReady()) {
                graphene_1.default.increment({
                    metricsName: "BlizzardEvents.InitBlizzard.AuthTokenFetchFailed",
                    value: 1,
                    dimensions: { status: resp.status.toString() },
                });
            }
            authState.next(blizzard_1.UNAUTH_STATE);
        }
    })
        .catch((e) => {
        authState.next(blizzard_1.UNAUTH_STATE);
        if (graphene_1.default.isReady()) {
            graphene_1.default.increment({
                metricsName: "BlizzardEvents.InitBlizzard.AuthTokenFetchError",
                value: 1,
            });
        }
        web_log_1.log.error(e);
    });
}
function subscribeToSnapchatComMetricsSSO(authState, isProd) {
    callAccountsSSO(authState, isProd);
    // try and fetch SSO token every 2 minutes if user is still on page
    setInterval(() => callAccountsSSO(authState, isProd), 120000);
}
// Blizzard cookie should only be set if:
// - user has explicitly accepted performance cookies
// - user is definitely not in a GDPR country
function blizzardCookieEnabled(isGDPRCountry) {
    return (0, web_sc_cookies_1.hasAcceptedPerformanceCookies)() || isGDPRCountry === false;
}
function initBlizzardWebClient(config) {
    if (!exports.hasBlizzardBeenInitialized) {
        const authStateObservable = config.authStateObservable ?? new observable_1.Observable(blizzard_1.UNSET_AUTH_STATE);
        // use UA data to identify device type and default to assuming user is on mobile
        // we can't use the useMediaQuery hook as we render mobile by default first so desktop
        // views are also tagged as mobile using that approach
        const isDesktop = (0, web_extraction_1.isDesktopUA)();
        const appVersion = process.env.NEXT_PUBLIC_APP_VERSION;
        (0, blizzard_1.initBlizzard)({
            debugLoggingEnabled: !config.isProd,
            appEnvironment: {
                appType: isDesktop ? "WEB_DESKTOP" : "WEB_MOBILE",
                appBuild: "PROD",
                appVersion,
            },
            clientAuthProvider: {
                ssoClientId: blizzard_1.SsoClientId.SNAPCHAT_COM,
                // blizzard SDK waits until this authState is set before actually initializing.
                authState: authStateObservable,
            },
            webClientId: (0, web_sc_cookies_1.tryGetWebClientId)((0, web_env_1.getDocument)()?.cookie),
            mode: blizzard_1.CollectionMode.PROD,
            lifecycleConfig: {
                reportWebPageOpen: config.withWebPageOpen,
            },
            cookiesDisabled: !blizzardCookieEnabled(config.isGDPRCountry),
            metricsAppId: config.metricsAppId,
        });
        if (config.withWebPageOpen) {
            if (graphene_1.default.isReady()) {
                graphene_1.default.increment({
                    metricsName: "BlizzardEvents.InitBlizzard.WithWebPageOpen",
                    value: 1,
                });
            }
            subscribeToSnapchatComMetricsSSO(authStateObservable, config.isProd);
        }
        else {
            if (graphene_1.default.isReady()) {
                graphene_1.default.increment({
                    metricsName: "BlizzardEvents.InitBlizzard.WithoutWebPageOpen",
                    value: 1,
                });
            }
        }
        setBlizzardHasBeenInitialized(true);
    }
}
exports.initBlizzardWebClient = initBlizzardWebClient;
//# sourceMappingURL=blizzard.js.map